import type { Locale } from '../locales';

export interface ExhibitData {
  id: number;
  order: number;
  title: string;
  description: string;
  zone: string;
  position: { x: number; y: number };
  audio?: string;
}

export type ExhibitIndex = number;

// Position data for each exhibit (these would be the actual coordinates on your map)
const exhibitPositions: Record<number, { x: number; y: number }> = {
  1: { x: 55, y: 82 },
  2: { x: 75, y: 73.5 },
  3: { x: 67, y: 64.5 },
  4: { x: 70, y: 71.5 },
  5: { x: 37.5, y: 70 },
  6: { x: 70, y: 49 },
  // 7: { x: 80, y: 44},
  7: { x: 67.5, y: 37.5 },
  8: { x: 62.5, y: 41 },
  9: { x: 69.5, y: 44.5 },
  10: { x: 44, y: 53 },
};

// Audio file mappings (add your actual audio file paths here)
const exhibitAudio: Record<number, string | undefined> = {
  1: '/audio/1.webm',
  2: '/audio/2.webm',
  3: '/audio/3.webm',
  4: '/audio/4.webm',
  5: '/audio/5.webm',
  6: '/audio/6.webm',
  // 7: '/audio/7.webm',
  7: '/audio/7.webm',
  8: '/audio/8.webm',
  9: '/audio/9.webm',
  10: '/audio/10.webm',
};

export const getExhibitsData = (locale: Locale): ExhibitData[] => {
  const exhibitsData: ExhibitData[] = [];
  
  // Convert locale exhibits to our format
  Object.entries(locale.exhibits).forEach(([key, exhibit]) => {
    const id = parseInt(key, 10);
    exhibitsData.push({
      id,
      order: id,
      title: exhibit.title,
      description: exhibit.description,
      zone: exhibit.zone,
      position: exhibitPositions[id] || { x: 50, y: 50 }, // fallback position
      audio: exhibitAudio[id],
    });
  });

  return exhibitsData.sort((a, b) => a.order - b.order);
};